import { render, staticRenderFns } from "./InterestCategoryList.vue?vue&type=template&id=c5f43ffa"
import script from "./InterestCategoryList.vue?vue&type=script&lang=js"
export * from "./InterestCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports